<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div class="">
      <h1 class="md:hidden bg-stone-white text-[30px] font-semibold py-2 px-4">
        {{ adviceDetail.title }}
      </h1>
      <HelpHeroCard
        :heroCardData="adviceDetail"
        className=""
        :fullBanner="false"
      ></HelpHeroCard>
      <div
        class="bg-stone-white"
        v-if="
          adviceDetail.list_type == 'tests'
            ? adviceDetail.tests.length > 0
            : adviceDetail.conditions.length > 0
        "
      >
        <NuxtLayout name="stretch" class="md:py-32 py-12">
          <h2 class="mb-8">{{ adviceDetail.conditions_title }}</h2>
          <div class="flex flex-row flex-wrap">
            <HelpList
              :categorySlug="route.params.category"
              :listData="item"
              :listType="adviceDetail.list_type"
              v-for="(item, index) in ordereredConditions"
              :key="index"
              :total="ordereredConditions.length"
              displayList="row"
            ></HelpList>
          </div>
        </NuxtLayout>
      </div>

      <NuxtLayout name="center">
        <div class="">
          <div class="pt-12 md:pt-20 md:pb-16 justify-center">
            <CommonUSPBlock :itemList="uspitems.data"></CommonUSPBlock>
          </div>
          <div
            class="bg-primary-600 md:px-16 lg:px-24 xl:px-32 md:pt-16 lg:pt-24 pt-12 relative pb-20 md:pb-28 md:rounded-lg"
          >
            <h2 class="text-2xl mb-8 mx-4">
              {{ adviceDetail.booking_service_title }}
            </h2>
            <div
              v-html="adviceDetail.booking_service_text"
              class="text-lg-30 px-8"
            ></div>
            <BaseTypography
              variant="h3"
              class="px-8 mt-6 md:-mb-12"
              v-if="adviceDetail.service_types.length > 1"
              >{{
                $t("pages.help_and_advice.book_test.choose_service_type")
              }}</BaseTypography
            >
          </div>
          <div
            class="mx-4 md:mx-0 -mt-16 md:-mt-12 md:px-16 lg:px-24 xl:px-32"
            v-if="adviceDetail.service_types.length > 0"
          >
            <div
              class="grid grid-cols-1 md:grid-cols-2 gap-[1px] relative md:py-0"
              :class="{
                'overflow-hidden rounded-lg shadow-default bg-slate-300':
                  adviceDetail.service_types.length > 1,
              }"
            >
              <a
                v-for="(serviceList, index) in adviceDetail.service_types"
                :key="index"
                :href="`/${switchBlogLocale()}/get-started/sexual-health/${
                  serviceList.slug
                }`"
                :class="{
                  'md:col-start-2 rounded-lg shadow-default': Boolean(
                    adviceDetail.service_types.length === 1,
                  ),
                }"
                @click.prevent="handleGetStartedLinkClick(serviceList)"
              >
                <CommonServiceTypeBlock
                  class="h-full bg-white overflow-hidden"
                  :serviceList="serviceList"
                />
              </a>
              <div
                v-if="Boolean(adviceDetail.service_types.length % 2)"
                class="bg-white w-full h-full"
              ></div>
            </div>
          </div>
        </div>
      </NuxtLayout>

      <!-- Doctor's Consultation Block -->
      <!---
      <div class="bg-secondary-lighter md:mt-36 border-b-8 border-primary">
        <NuxtLayout name="help" class="md:px-16">
          <div class="md:px-40 px-4">
            <div class="py-14 md:py-20 md:pb-0">
              <h2 class="text-2xl mb-8">
                {{ adviceDetail.doctor_consultation_title }}
              </h2>
              <div
                v-html="adviceDetail.doctor_consultation_text"
                class="text-lg-30"
              ></div>
            </div>
            <div class="flex flex-row flex-wrap-reverse gap-20">
              <div
                class="flex flex-col h-fit mt-auto relative flex-shrink-0 -mb-[1px]"
              >
                <NuxtImg src="/img/USPs_graphics-02.svg" alt="graphic" />
              </div>
              <div
                class="flex flex-row flex-wrap flex-1 lg:translate-y-[3rem] gap-4 justify-center md:justify-start"
              >
                <HelpConsultationCard
                  :icon="consultationIcon"
                  description="See a doctor to discuss your health concerns and
                get the answers you need"
                  title="Consultation"
                  link="/en-gb/tests"
                />
              </div>
            </div>
          </div>
        </NuxtLayout>
      </div>
  --->
      <NuxtLayout name="center" class="md:pt-11">
        <CommonLiveChatBlock></CommonLiveChatBlock>
      </NuxtLayout>

      <div class="mt-12 md:mt-20" v-if="adviceDetail.faqs.length > 0">
        <h2 class="text-center px-8 md:px-0">STD and STI Testing: F.A.Q.</h2>
        <CommonFaqAndLiveChatBlock
          :faqData="adviceDetail.faqs"
        ></CommonFaqAndLiveChatBlock>
      </div>
      <div
        class="bg-secondary-lighter mb-16 md:mb-24 pt-14 md:pt-20 pb-12 md:pb-0"
      >
        <NuxtLayout
          name="center"
          class="pb-14 md:pb-20 max-w-[843px] mx-4 md:mx-auto md:px-0 text-start"
        >
          <h2>{{ adviceDetail.content_blocks_title }}</h2>
          <div
            v-html="adviceDetail.content_blocks_text"
            class="tracking-[0.22px] text-lg-30 font-semibold mt-6 md:mt-12"
          ></div>
        </NuxtLayout>
        <div class="flex flex-col gap-8 md:gap-12 w-full md:mx-auto">
          <CommonContentBlock
            v-for="(content_block, index) in adviceDetail.content_blocks"
            :key="index"
            :contentData="content_block"
            :index="index"
          ></CommonContentBlock>
        </div>
      </div>

      <CommonLatestBlogs
        v-if="globalStore.siteSettings.display_blog == true"
        category="3522"
        :title="$t('blog.latestSexualHealthBlog', { name: '' })"
        button-title=""
      >
      </CommonLatestBlogs>

      <ClinicCTABlock
        imgSrc="USPs_graphic_03_1"
        :getStarted="true"
      ></ClinicCTABlock>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();
const route = useRoute();
const adviceDetail = ref({});
const { data: resultData } = await useHelpAdviceDetailSlug(
  route.params.category,
);
adviceDetail.value = resultData.value.data;

const ordereredConditions = computed(() => {
  const items =
    adviceDetail.value.list_type === "tests"
      ? adviceDetail.value.tests
      : adviceDetail.value.conditions;

  return items.sort((a, b) => a.title.localeCompare(b.title));
});

const isMobile = useScreenSize("sm");
const consultationIcon = ref(
  `<NuxtImg loading="lazy" src="/icons/b-comment.svg" alt="" class="max-w-[3rem]" />`,
);

const { data: uspitems, refreshUSPItems } = await useUSPItems(1);
useMetaTitles(adviceDetail.value, "help-and-advice-category");

const breadcrumbs = getBreadcrumbs(
  "help-and-advice-category",
  adviceDetail.value,
);

generateSchema("help-and-advice-category", adviceDetail.value.faqs);

async function handleGetStartedLinkClick(service) {
  const targetHref = `/${switchBlogLocale()}/get-started/sexual-health/${
    service.slug
  }`;
  const url = new URL(targetHref, window.location.origin);

  const _navigate = (additionalParams) =>
    navigateTo({
      path: url.pathname,
      query: {
        ...Object.fromEntries(url.searchParams.entries()),
        ...additionalParams,
      },
    });

  const customParams = {
    "everywhere-nurse-service": {
      searchTerm: !globalStore.siteSettings.everywhere_address_lookup
        ? "*"
        : undefined,
    },
  };
  await _navigate(customParams[service.slug]);
}
</script>
<style scoped>
@media only screen and (min-width: 1024px) {
  div.sub-category:nth-child(6) {
    border-top-width: 2px;
  }

  div.sub-category:nth-child(11) {
    border-top-width: 2px;
  }
}
</style>
